import { appInfo } from '../config/appinfo'

const fetchAPI = async (url: string, options = {}) => {
  const response = await fetch(url, options)
  if (!response.ok) {
    throw new Error(`Failed to fetch: ${response.statusText}`)
  }
  return response.json()
}

export const dashboardAPI = {
  getDayStreak: () =>
    fetchAPI(`${appInfo.apiDomain}/api/dashboard/dayStreak`),
  
  geMoudleData: () =>
    fetchAPI(`${appInfo.apiDomain}/api/dashboard/modules`),

  getLabProgressSummary: () =>
    fetchAPI(`${appInfo.apiDomain}/api/labs/progress/summary`),
  
  getCourseModules: (courseId: string) =>
    fetchAPI(`${appInfo.apiDomain}/api/labs/courses/${courseId}/labmodules`, {
      credentials: 'include'
  }),
}